import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AddAPhotoRoundedIcon from '@material-ui/icons/AddAPhotoRounded';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UserModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState, globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [errorMessages, setErrorMessages] = useState([]);
    const [schoolsDropdown, setSchoolsDropdown] = useState([]);
    const [rolesDropdown, setRolesDropdown] = useState([]);
    const [file, setFile] = useState('');
    const [fileUploadLabel, setFileUploadLabel] = useState(
        <><AddAPhotoRoundedIcon /> <p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (optional)</p></>
    );

    const [user, setUser] = useState({
        school_id: '',
        role_id: '',
        name: '',
        avatar: '',
        email: ''
    });

    async function createUser(values, resetForm) {

        const formData = new FormData();
        formData.append('avatar', file);
        formData.append('school_id', values.school_id);
        formData.append('role_id', values.role_id);
        formData.append('name', values.name);
        formData.append('email', values.email);

        try {

            const res = await axiosConfig.post(`/users`, formData);

            if (res.data.status_code == 'ok') {
                setFile('');
                setFileUploadLabel(<><AddAPhotoRoundedIcon /> <p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (optional)</p></>);
                globalDispatch({type: 'setSnackbarMsg', value: 'User created successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});

                props.fetchUsers();
                props.handleClose();
            }

        } catch (err) {

            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    async function updateUser(values, resetForm) {

        const formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('user_id', props.selectedUser.id);
        formData.append('avatar', file);
        formData.append('school_id', values.school_id);
        formData.append('role_id', values.role_id);
        formData.append('name', values.name);
        formData.append('email', values.email);

        try {

            const res = await axiosConfig.post(`/users/${props.selectedUser.id}`, formData);

            if (res.data.status_code == 'ok') {
                setFile('');
                setFileUploadLabel(<><AddAPhotoRoundedIcon /> <p style={{marginLeft: '5px', fontWeight: '500'}}>Choose a file to upload (optional)</p></>);
                globalDispatch({type: 'setSnackbarMsg', value: 'User updated successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});

                props.fetchUsers();
                props.handleClose();
            }

        } catch (err) {
            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    const fetchSchools = () => {
        axiosConfig.get('/schools')
            .then(response => {
                const { data } = response.data;
                setSchoolsDropdown(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const fetchRoles = () => {
        axiosConfig.get('/roles')
            .then(response => {
                const { data } = response.data;
                setRolesDropdown(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    const handleFileChange = (event) => {
        try {
            console.log(event.target.files[0].name);
            setFileUploadLabel(event.target.files[0].name);
            setFile(event.target.files[0]);
        } catch (e) {
            return;
        }
    }

    useEffect(() => {

        setErrorMessages('');

        if (props.selectedUser) {
            setUser({
                school_id: props.selectedUser.school_id,
                role_id: props.selectedUser.role_id,
                name: props.selectedUser.name,
                avatar: '',
                email: props.selectedUser.email
            });
        }

        fetchSchools();
        fetchRoles();

    }, [props.selectedUser]);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={'sm'}
            TransitionComponent={Transition}
            disableBackdropClick
        >
            <Formik
                initialValues={user}
                validate={(values) => {
                    const errors = {};

                    if (!values.role_id) {
                        errors.role_id = 'This field is required';
                    }

                    if (!values.name) {
                        errors.name = 'This field is required';
                    }

                    if (!values.email) {
                        errors.email = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {

                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});

                    // setTimeout(() => {
                    //     setSubmitting(false);
                    //     alert(JSON.stringify(values, null, 2));
                    //     resetForm();
                    //     globalDispatch({type: 'setIsLoading', value: false});
                    // }, 500);

                    if (props.selectedUser === null) {
                        createUser(values, resetForm);
                    } else {
                        updateUser(values, resetForm);
                    }
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form encType="multipart/form-data">
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container alignItems="flex-start" spacing={2}>

                                {errorMessages.length > 0 && (
                                    <Grid item xs={12}>
                                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                            {errorMessages.map((key, i) => (
                                                <Typography key={i}>
                                                    {key}
                                                </Typography>
                                            ))}
                                        </Alert>
                                    </Grid>
                                )}

                                { authState.user.role_id === 1 && (
                                    <Grid item xs={12}>
                                        <Field
                                            error={errors.school_id && true}
                                            component={Select}
                                            name="school_id"
                                            multiple={false}
                                            inputProps={{name: 'school_id', id: 'school_id'}}
                                            fullWidth
                                            variant="outlined"
                                            displayEmpty
                                        >
                                            <MenuItem value={``}>-Select School-</MenuItem>

                                            {schoolsDropdown.map((school, i) => (
                                                <MenuItem key={school.id} value={school.id}>
                                                    {school.name}
                                                </MenuItem>
                                            ))}
                                        </Field>

                                        {errors.school_id && (
                                            <Box px={1.5}>
                                                <FormHelperText error={true}>
                                                    {errors.school_id}
                                                </FormHelperText>
                                            </Box>
                                        )}
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Field
                                        error={errors.role_id && true}
                                        component={Select}
                                        name="role_id"
                                        multiple={false}
                                        inputProps={{name: 'role_id', id: 'role_id'}}
                                        fullWidth
                                        variant="outlined"
                                        displayEmpty
                                    >
                                        <MenuItem value={``}>-Select Role-</MenuItem>

                                        {rolesDropdown.map((role, i) => (
                                            <MenuItem key={role.id} value={role.id}>
                                                {role.name}
                                            </MenuItem>
                                        ))}
                                    </Field>

                                    {errors.role_id && (
                                        <Box px={1.5}>
                                            <FormHelperText error={true}>
                                                {errors.role_id}
                                            </FormHelperText>
                                        </Box>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Full Name (required)"
                                        name="name"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Box py={1}>
                                        <Button
                                            // className={props.classes.truncate}
                                            variant="outlined"
                                            size="medium"
                                            component="label"
                                            fullWidth
                                            type="button"
                                            style={{justifyContent: "flex-start"}}
                                        >
                                            {fileUploadLabel}
                                            <input type="file" onChange={handleFileChange} hidden />
                                        </Button>
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Email Address (required)"
                                        name="email"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={props.handleClose}
                                disabled={isSubmitting}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting}
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default UserModalForm;